// Font size presets for CTA titles: [min (px), preferred (vw), max (px)]
// Uses clamp() for fluid typography, similar to hero-index block
export const CTA_FONT_PRESETS: Record<string, [number, number, number]> = {
	small: [28, 3, 48],
	medium: [32, 4, 64],
	large: [36, 5, 80],
	xlarge: [40, 6, 96],
}

export const CTA_DEFAULT_FONT_PRESET = 'medium'
